import ApiController, { ApiRequest } from "../controller";

class LocationModule extends ApiController {
  resource = "";

  customDomain({ domain, verify } : { domain: string, verify?: string }) {
    const data = {
      domain,
      verify: verify || null
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/customDomain`,
      body: data
    });

    return this.request<any>(request);
  }

  info() {
    const request = new ApiRequest({
      method: "GET",
      url: `/info`,
      redirectOnUnauthorized: false
    });

    return this.request<any>(request);
  }

  service(id) {
    const request = new ApiRequest({
      method: "GET",
      url: `/service`,
      query: {
        id
      }
    });

    return this.request<any>(request);
  }

  reviews(page, limit) {
    const data = {
      page,
      limit
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/reviews`,
      body: data
    });

    return this.request<any>(request);
  }

  employees(ids) {
    const data = {
      ids
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/employees`,
      body: data,
      query: {
        limit: '100'
      }
    });

    return this.request<any>(request);
  }

  instagramFeed() {
    const request = new ApiRequest({
      method: "GET",
      url: `/instagramFeed`
    });

    return this.request<any>(request);
  }

  getState({ key, auth }) {
    const request = new ApiRequest({
      method: "GET",
      url: `/state`,
      query: {
        key,
        auth
      }
    });

    return this.request<any>(request);
  }

  setState({ data, key = null, auth = null }) {
    const requestData = {
      key,
      auth,
      data
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/state`,
      body: requestData
    });

    return this.request<any>(request);
  }

  customPage({ slug }) {
    const requestData = {
      slug
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/customPage`,
      body: requestData
    });

    return this.request<any>(request);
  }

  services(ids) {
    const requestData = {
      ids,
      format: 'list'
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/services`,
      body: requestData,
      query: {
        limit: '100'
      }
    });

    return this.request<any>(request);
  }
}

export default LocationModule;
